import React, { useState, useEffect } from 'react';
import { Modal, message } from 'antd';
import IntegerQtyInput from './integerQtyInput';
import Rest from 'tools/rest';
import UserSelect from 'components/user_search';
import {
  formatQuantityWithUnit,
  materialDisplayUnit,
  parseMaterialIntegerQty,
  availableQtyFloor,
  isQuantityExplicitZero,
} from '../utils';

const TransferModal = ({ visible, material, onClose, onSuccess }) => {
  const [userId, setUserId] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setUserId(null);
      setQuantity(null);
    }
  }, [visible, material?.id]);

  const handleOk = () => {
    if (!userId) {
      message.error('Выберите получателя');
      return;
    }
    if (isQuantityExplicitZero(quantity)) {
      message.error('Количество должно быть больше 0');
      return;
    }
    const q = parseMaterialIntegerQty(quantity);
    if (q === null) {
      message.error('Укажите целое количество не меньше 1');
      return;
    }
    const available = availableQtyFloor(material);
    if (q > available) {
      message.error(
        `Недостаточно на складе (доступно: ${formatQuantityWithUnit(available, materialDisplayUnit(material))})`
      );
      return;
    }

    setLoading(true);
    Rest.post('/api/v1/material_moves.json', {
      material_move: {
        source_type: 'WarehouseMaterial',
        source_id: material.id,
        destination_type: 'Inventory',
        destination_user_id: userId,
        material_id: material.material_id,
        quantity: q,
      },
    })
      .then(() => {
        message.success('Материал перемещён');
        setUserId(null);
        setQuantity(null);
        onSuccess();
        onClose();
      })
      .catch((err) => {
        message.error(err.response?.data?.errors?.join(', ') || 'Ошибка перемещения');
      })
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    setUserId(null);
    setQuantity(null);
    onClose();
  };

  return (
    <Modal
      title={`Переместить: ${material?.material_name || ''}`}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Переместить"
      cancelText="Отмена"
    >
      <p style={{ marginBottom: 8 }}>Кому переместить:</p>
      <UserSelect
        scope="warehouse_users"
        onChange={(_, opt) => setUserId(opt ? opt.value : null)}
        value={userId}
        placeholder="Получатель"
        style={{ width: '100%', marginBottom: 16 }}
      />
      <p style={{ marginBottom: 4 }}>
        Доступно на складе:{' '}
        <strong>{formatQuantityWithUnit(material?.quantity, materialDisplayUnit(material))}</strong>
      </p>
      <IntegerQtyInput
        value={quantity}
        onChange={setQuantity}
        style={{ width: '100%' }}
        placeholder="Только целое число, не больше остатка"
      />
    </Modal>
  );
};

export default TransferModal;
